import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import 'whatwg-fetch';
import { appendGraphQlMajorEntity, findAssociatedMajorEntity } from 'src/utils/utilPlanning';
import InputUpdate from '../input/inputUpdate';
import TextAreaUpdate from '../input/textareaUpdate';

import ModalReturnEmployee from '../modal/modalReturnEmployee';
import ModalConfirm from '../modal/modalConfirm';

import data_criticity from 'src/data/criticity';
import DatePickerUpdate from '../input/datepickerUpdate';
import TimePickerUpdate from '../input/timepickerUpdate';
import SubNavBar from '../SubNavBar';
import withAuth from 'src/hoc/withAuth';

const apiAppointmentShow = '/api/appointment/show/';
const linkToUser = '/dashboard/user/';

const apiAppointmentType = '/api/appointment/getAppointmentTypes/';

class DisplayAppointment extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      notFound: false,
      appViewNavExtended: false, // Extend the menu behind the appViewNav
      isModalAppointmentCloseOpen: false,
      isModalAppointmentChangeOpen: false,
      isModalRemoveEmployeeOpen: false,
      isModalAddEmployeeOpen: false,
      textModal: {
        title: undefined,
        message: undefined,
      },
      title: '____',
      text: '____',
      criticity: '____',
      majorEntity: undefined,
      dateCreated: '____',
      dateMeeting: '____',
      place: '____',
      appointmentType: undefined,
      duration: 0,
      creator: {
        user: {
          id: undefined,
          username: undefined,
        },
      },
      employeesConcerned: undefined,
      dataAppointmentTypes: undefined,
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleAppointmentChange = this.handleAppointmentChange.bind(this);
    this.changeAppointmentState = this.changeAppointmentState.bind(this);
    this.closeAppointment = this.closeAppointment.bind(this);
    this.openModalAppointmentChange = this.openModalAppointmentChange.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.updateField = this.updateField.bind(this);
    this.updateEmployee = this.updateEmployee.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }
  handleAppointmentChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    let graphKey;

    switch (name) {
      case 'criticity':
        graphKey = 'criticity';
        break;
      case 'appointmentType':
        graphKey = 'appointmentTypeId';
        break;
    }

    this.openModalAppointmentChange(graphKey, value);
  }

  componentDidMount() {
    if (this.props.match.params.id) {
      // check if id supplied in the route
      const paramsID = this.props.match.params.id;

      let queryURL = apiAppointmentShow;
      let graphQL =
        '{ appointment(id:' +
        paramsID +
        '){ id, title, text, criticity, closed, creator{ id, user{ id, username } }, dateMeeting, dateCreate, place, duration,' +
        'employeesConcerned{ id, user{ id, username } },' +
        'appointmentType{ id, name }' +
        appendGraphQlMajorEntity() +
        ' } }';
      queryURL += graphQL;
      this.props
        .authFetch(queryURL, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          method: 'GET',
        })
        .then((resp) => resp.json())
        .then(
          function (data) {
            if (data['data']['appointment']) {
              this.setState({
                entity: data['data']['appointment'],
                title: data['data']['appointment']['title'],
                text: data['data']['appointment']['text'],
                criticity: data['data']['appointment']['criticity'],
                majorEntity: findAssociatedMajorEntity(data['data']['appointment']),
                dateCreated: data['data']['appointment']['dateCreate'],
                dateMeeting: data['data']['appointment']['dateMeeting'],
                place: data['data']['appointment']['place'],
                duration: data['data']['appointment']['duration'],
                isClosed: data['data']['appointment']['closed'],
                creator: data['data']['appointment']['creator'],
                employeesConcerned: data['data']['appointment']['employeesConcerned'],
                appointmentType: data['data']['appointment']['appointmentType'],
              });
            } else {
              // not found
              this.setState({ notFound: true });
            }
            //console.log(data);
          }.bind(this)
        )
        .catch(
          function (error) {
            console.log('erreur fetch appointment entity: \n' + error);
          }.bind(this)
        );

      this.getAppointmentTypes();
    }
  }

  getAppointmentTypes = () => {
    this.props
      .authFetch(apiAppointmentType, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then((data) => {
        this.setState({
          dataAppointmentTypes: data['data']['appointmentTypes'],
        });
      })
      .catch((error) => {
        console.log('erreur fetch appointment types');
      });
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.id != this.props.match.params.id) {
      // Route reloaded
      this.componentDidMount();
    }
  }

  toggleAppViewNavExtended() {
    this.setState({
      appViewNavExtended: !this.state.appViewNavExtended,
    });
  }

  render() {
    if (this.state.notFound === true || !this.props.match.params.id) return null;

    const { employeesConcerned } = this.state;

    let noEmployees =
      this.state.employeesConcerned != undefined && this.state.employeesConcerned.length === 0 ? (
        <span>Aucun employé associé</span>
      ) : (
        ''
      );

    return (
      <div id='appView' className='div-entity'>
        <SubNavBar
          toggleAppViewNavExtended={() => this.toggleAppViewNavExtended()}
          goBack={this.props.history.goBack}
          appViewNavExtended={this.state.appViewNavExtended}
          title='Fiche Rdv'
        >
          <div className={'appViewNavMenu-alignRight'}>
            {!this.state.isClosed && (
              <button type='button' className='btn btn-sm btn-outline-success' onClick={() => this.openModal('close')}>
                <span className='icon icon-check'>Effectué</span>
              </button>
            )}
          </div>
        </SubNavBar>

        <div id='appViewContent'>
          <div className='entity-display'>
            <form>
              <InputUpdate
                inputType={'text'}
                inputLabel={'Titre'}
                inputValue={this.state.title}
                submitUpdate={(inputValue) => this.updateField(inputValue, 'text', 'title')}
                toggleBlackOut={() => this.props.toggleBlackOut()}
              />
              {this.state.majorEntity && (
                <div className='form-group'>
                  <label>{'Associé à ' + this.state.majorEntity.label}</label>
                  <Link to={this.state.majorEntity.linkTo + this.state.majorEntity.id}>
                    <input
                      name='majorEntity'
                      value={this.state.majorEntity.name}
                      onChange={this.handleInputChange}
                      type='text'
                      className='form-control'
                      readOnly
                    />
                  </Link>
                </div>
              )}
              {
                <div className={'form-group'}>
                  <label>Type de RDV </label>
                  <select
                    name='appointmentType'
                    value={this.state.appointmentType ? this.state.appointmentType.id : 'none'}
                    onChange={this.handleAppointmentChange}
                    className='form-control'
                  >
                    <option disabled value={'none'}></option>
                    {this.state.dataAppointmentTypes ? (
                      Object.entries(this.state.dataAppointmentTypes).map(([key, data]) => (
                        <option key={key} value={data.id}>
                          {data.name}
                        </option>
                      ))
                    ) : (
                      <span>Chargement...</span>
                    )}
                  </select>
                </div>
              }
              {this.state.isClosed ? (
                <div className='form-group'>
                  <label>{this.state.isClosed ? 'À eu lieu le' : 'Doit avoir lieu le'}</label>
                  <input
                    name='dateMeeting'
                    value={moment(this.state.dateMeeting).format('DD-MM-YY | HH:mm')}
                    onChange={this.handleInputChange}
                    type='text'
                    className='form-control'
                    readOnly
                  />
                </div>
              ) : (
                <div>
                  <DatePickerUpdate
                    inputType={'text'}
                    inputLabel={'Jour'}
                    inputValue={this.state.dateMeeting}
                    submitUpdate={(inputValue) => this.updateField(inputValue, 'date', 'dateMeeting')}
                    toggleBlackOut={() => this.props.toggleBlackOut()}
                  />
                  <TimePickerUpdate
                    inputType={'text'}
                    inputLabel={'Heure'}
                    inputValue={this.state.dateMeeting}
                    submitUpdate={(inputValue) => this.updateField(inputValue, 'time', 'dateMeeting')}
                    toggleBlackOut={() => this.props.toggleBlackOut()}
                  />
                </div>
              )}

              <div className='form-group'>
                <label>Criticité</label>
                {!this.state.isClosed ? (
                  <select
                    name='criticity'
                    value={this.state.criticity}
                    onChange={this.handleAppointmentChange}
                    className='form-control'
                  >
                    {data_criticity ? (
                      Object.entries(data_criticity).map(([key, data]) => (
                        <option key={key} value={key}>
                          {key + '-' + data.fr}
                        </option>
                      ))
                    ) : (
                      <span>Chargement...</span>
                    )}
                  </select>
                ) : (
                  <input
                    name='criticity'
                    value={this.state.criticity + '-' + data_criticity[this.state.criticity].fr}
                    onChange={this.handleInputChange}
                    type='text'
                    className='form-control'
                    readOnly
                  />
                )}
              </div>

              <InputUpdate
                inputType={'text'}
                inputLabel={'Lieu'}
                inputValue={this.state.place}
                submitUpdate={(inputValue) => this.updateField(inputValue, 'text', 'place')}
                toggleBlackOut={() => this.props.toggleBlackOut()}
              />

              <InputUpdate
                inputType={'number'}
                inputLabel={'Durée prévue (en min)'}
                inputValue={this.state.duration}
                submitUpdate={(inputValue) => this.updateField(inputValue, 'number', 'duration')}
                toggleBlackOut={() => this.props.toggleBlackOut()}
              />

              <div className='form-group'>
                <label>Créé le</label>
                <input
                  name='dateCreated'
                  value={moment(this.state.dateCreated).format('DD-MM-YY | HH:mm')}
                  onChange={this.handleInputChange}
                  type='text'
                  className='form-control'
                  readOnly
                />
              </div>

              <div className='form-group'>
                <label>Créateur</label>
                <Link to={linkToUser + this.state.creator.user.id}>
                  <input
                    name='creator'
                    value={this.state.creator.user.username}
                    onChange={this.handleInputChange}
                    type='text'
                    className='form-control'
                    readOnly
                  />
                </Link>
              </div>
              <div className='form-group'>
                <div className='alignHorizontal'>
                  <label>Personnes concernées</label>
                  <button
                    onClick={() => this.openModal('employee-add')}
                    type='button'
                    className='btn btn-sm btn-outline-success'
                  >
                    <span className='icon icon-plus'></span>
                  </button>
                </div>
                {employeesConcerned ? (
                  employeesConcerned.map((data) => (
                    <li className='list-group-item entity-row' key={data.user.id}>
                      <Link to={linkToUser + data.user.id}>
                        <span>{'@' + data.user.username}</span>
                      </Link>
                      <button
                        onClick={() => this.openModal('employee-remove', data.id)}
                        type='button'
                        className='btn btn-sm btn-outline-success'
                      >
                        <span className='icon icon-cross'></span>
                      </button>
                    </li>
                  ))
                ) : (
                  <span>Chargement...</span>
                )}
                {noEmployees}
              </div>
              <TextAreaUpdate
                inputType={'text'}
                inputLabel={'Commentaire'}
                inputValue={this.state.text}
                submitUpdate={(inputValue) => this.updateField(inputValue, 'text', 'text')}
                toggleBlackOut={() => this.props.toggleBlackOut()}
              />
            </form>
          </div>
        </div>

        <ModalConfirm
          className='myModal'
          modalText={this.state.textModal}
          isOpen={this.state.isModalAppointmentChangeOpen}
          onSubmit={this.changeAppointmentState}
          onClose={this.closeModal}
          onCancel={this.closeModal}
        />

        <ModalConfirm
          className='myModal'
          modalText={this.state.textModal}
          isOpen={this.state.isModalAppointmentCloseOpen}
          onSubmit={this.closeAppointment}
          onClose={this.closeModal}
          onCancel={this.closeModal}
        />

        <ModalConfirm
          className='myModal'
          modalText={this.state.textModal}
          isOpen={this.state.isModalRemoveEmployeeOpen}
          onSubmit={() => this.updateEmployee([], 'employeesToRemove')}
          onClose={this.closeModal}
          onCancel={this.closeModal}
        />

        <ModalReturnEmployee
          multi={true}
          className='myModal'
          modalText={this.state.textModal}
          isOpen={this.state.isModalAddEmployeeOpen}
          openToast={this.props.openToast}
          onPostResult={(employeeList) => this.updateEmployee(employeeList, 'employeesToAdd')}
          onClose={this.closeModal}
        />
      </div>
    );
  }

  openModalAppointmentChange(graphKey, newState) {
    let modal = {
      title: 'Rdv',
      message: "Vous allez modifiez l'état du rdv",
    };
    this.props.toggleBlackOut();
    this.setState({
      textModal: modal,
      isModalAppointmentChangeOpen: true,
      appointmentChangeGraphKey: graphKey,
      appointmentChangeNewState: newState,
    });
  }

  openModal = (type, param1 = undefined) => {
    let toOpen = undefined;
    switch (type) {
      case 'employee-add':
        this.setState({
          textModal: {
            title: 'Rdv',
            message: 'Ajouter des employés au rendez-vous.',
          },
        });
        toOpen = 'isModalAddEmployeeOpen';
        break;
      case 'employee-remove':
        this.setState({
          textModal: {
            title: 'Rdv',
            message: 'Vous allez supprimer cet employé du rendez-vous.',
          },
          employeeIdToRemove: param1,
        });
        toOpen = 'isModalRemoveEmployeeOpen';
        break;
      case 'close':
        this.setState({
          textModal: {
            title: 'Rdv',
            message: 'Vous allez marquer ce rendez-vous comme étant effectué.',
          },
        });
        toOpen = 'isModalAppointmentCloseOpen';
        break;
    }
    this.props.toggleBlackOut();
    this.setState({
      [toOpen]: true,
      appViewNavExtended: false,
    });
  };

  closeModal() {
    this.props.toggleBlackOut();
    this.setState({
      isModalAppointmentChangeOpen: false,
      isModalAppointmentCloseOpen: false,
      isModalRemoveEmployeeOpen: false,
      isModalAddEmployeeOpen: false,
    });
  }

  changeAppointmentState() {
    if (this.props.match.params.id && this.state.appointmentChangeGraphKey && this.state.appointmentChangeNewState) {
      const paramsID = this.props.match.params.id;

      let queryURL = apiAppointmentShow;
      let graphQL = '';
      if (this.state.appointmentChangeGraphKey === 'appointmentTypeId') {
        graphQL +=
          'mutation{ appointment(id:' +
          paramsID +
          ',' +
          this.state.appointmentChangeGraphKey +
          ':' +
          this.state.appointmentChangeNewState +
          ' ){ id } }';
      } else {
        graphQL +=
          'mutation{ appointment(id:' +
          paramsID +
          ',' +
          this.state.appointmentChangeGraphKey +
          ':' +
          this.state.appointmentChangeNewState +
          ' ){ id, ' +
          this.state.appointmentChangeGraphKey +
          ' } }';
      }
      queryURL += graphQL;
      this.props
        .authFetch(queryURL, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          method: 'POST',
        })
        .then((resp) => resp.json())
        .then(
          function (data) {
            if (this.state.appointmentChangeGraphKey === 'appointmentTypeId') {
              if (data['data']['appointment']) {
                this.componentDidMount();
                this.props.openToast(true, 'Le rdv a été modifié');
              } else {
                this.props.openToast(false, 'Erreur modification rdv. Veuillez réessayer');
              }
            } else {
              if (
                data['data']['appointment'][this.state.appointmentChangeGraphKey] ===
                Number(this.state.appointmentChangeNewState)
              ) {
                this.componentDidMount();
                this.props.openToast(true, 'Le rdv a été modifié');
              } else {
                this.props.openToast(false, 'Erreur modification rdv. Veuillez réessayer ');
              }
            }
          }.bind(this)
        )
        .catch(
          function (rror) {
            console.log(rror);
          }.bind(this)
        );
    }
  }

  closeAppointment() {
    if (this.props.match.params.id) {
      const paramsID = this.props.match.params.id;

      let queryURL = apiAppointmentShow;
      let graphQL = 'mutation{ appointment(id:' + paramsID + ',closed:true){ id, closed } }';
      queryURL += graphQL;
      this.props
        .authFetch(queryURL, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          method: 'POST',
        })
        .then((resp) => resp.json())
        .then(
          function (data) {
            if (data['data']['appointment']['closed'] == true) {
              this.componentDidMount();
              this.props.openToast(true, 'La rdv a été effectué');
            } else {
              this.props.openToast(false, 'Erreur modification rdv. Veuillez réessayer');
            }
          }.bind(this)
        )
        .catch(
          function (rror) {
            console.log(rror);
            this.props.openToast(false, 'Erreur modification rdv. Veuillez réessayer');
          }.bind(this)
        );
    }
  }

  updateField(newValue, inputType, fieldName) {
    // !! Important-> the given "fieldName" attribute must be the name of the ORM attribute !!
    let newValueSent;
    if (inputType === 'text') {
      newValueSent = '"' + newValue.replace(/["]/g, '\\"') + '"';
    } else if (fieldName === 'dateMeeting' && inputType === 'time') {
      let oldDate = moment(this.state.dateMeeting);
      newValue = moment({
        year: oldDate.year(),
        month: oldDate.month(),
        day: oldDate.date(),
      })
        .seconds(newValue)
        .format('YYYY-MM-DD HH:mm');
      newValueSent = '"' + newValue.replace(/["]/g, '\\"') + '"';
    } else if (fieldName === 'dateMeeting' && inputType === 'date') {
      let oldDate = moment(this.state.dateMeeting);
      newValue = moment(newValue)
        .add({ hours: oldDate.get('hour'), minutes: oldDate.get('minute') })
        .format('YYYY-MM-DD HH:mm');
      newValueSent = '"' + newValue.replace(/["]/g, '\\"') + '"';
    } else {
      newValueSent = newValue;
    }
    let graphQL = 'mutation { appointment(id:' + this.props.match.params.id + ', ';
    graphQL += fieldName + ':' + newValueSent + ') { ' + fieldName + ' } }';

    let queryURL = apiAppointmentShow;
    let data = 'data=' + encodeURIComponent(graphQL);
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        method: 'POST',
        body: data,
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          if (fieldName === 'dateMeeting') {
            data['data']['appointment'][fieldName] = moment(data['data']['appointment'][fieldName]).format(
              'YYYY-MM-DD HH:mm'
            );
          }

          if (data['data']['appointment']) {
            this.props.openToast(true, 'Votre modification a bien été prise en compte.');
            if (fieldName === 'appointmentTypeId')
              this.setState({
                [fieldName]: newValue,
              });
          } else {
            this.props.openToast(false, 'Erreur lors de la modification. Veuillez réessayer.');
          }
          //console.log(data);
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch UPDATE appointment entity: \n' + error);
        }.bind(this)
      );
  }

  updateEmployee(employeeList, fieldName) {
    if (fieldName === 'employeesToRemove') {
      // case REMOVE
      employeeList = [
        {
          id: this.state.employeeIdToRemove,
        },
      ];
    }

    let graphQL = 'mutation { appointment(id:' + this.props.match.params.id + ', ';
    graphQL +=
      fieldName +
      ':' +
      JSON.stringify(employeeList) +
      ') { ' +
      'employeesConcerned{ id, user{ id, username } }' +
      ' } }';

    let queryURL = apiAppointmentShow;
    let data = 'data=' + encodeURIComponent(graphQL);
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        method: 'POST',
        body: data,
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          if (data['data']['appointment']['employeesConcerned']) {
            this.props.openToast(true, 'Votre modification a bien été prise en compte.');
            this.setState({
              employeesConcerned: data['data']['appointment']['employeesConcerned'],
            });
          } else {
            this.props.openToast(false, 'Erreur lors de la modification. Veuillez réessayer.');
          }
          //console.log(data);
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch UPDATE task entity: \n' + error);
        }.bind(this)
      );
  }
}

export default withAuth(DisplayAppointment);
